export default {"src":"/login-app/[GIT_HASH]/_next/static/media/panel_show_bottom.f2eb41fc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};